var exports = {
  "SF": "AutocompleteEmoji.module__sectionHeading___MVNDQl",
  "yF": "AutocompleteEmoji.module__divider___MVNDQl",
  "mI": "AutocompleteEmoji.module__emojiIcon___MVNDQl",
  "M9": "AutocompleteEmoji.module__stickerIconWrapper___MVNDQl",
  "F1": "AutocompleteEmoji.module__memeIconWrapper___MVNDQl",
  "lA": "AutocompleteEmoji.module__stickerIcon___MVNDQl",
  "Cu": "AutocompleteEmoji.module__memeIcon___MVNDQl",
  "_Q": "AutocompleteEmoji.module__memeVideo___MVNDQl",
  "BN": "AutocompleteEmoji.module__audioIconWrapper___MVNDQl",
  "iw": "AutocompleteEmoji.module__audioIcon___MVNDQl",
};

module.exports = exports;
